import { all, call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import { fetchSFVVisitsAPI } from '../../../services/group-admin-service';
import { FETCH_SFV_VISITS, FETCH_SFV_VISITS_ERROR, FETCH_SFV_VISITS_START, FETCH_SFV_VISITS_SUCCESS, SET_SFV_VISITS_PAGINATION } from '../../actions/groupadmin/submittedForVerificationActions';

function* fetchGroupAdminSFVVisits({ payload }) {
    try {
        yield put({ type: FETCH_SFV_VISITS_START })
        let response = yield call(fetchSFVVisitsAPI, payload);
        if (response.data) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalIstems,
            }
            yield put({ type: FETCH_SFV_VISITS_SUCCESS, submittedForVerification: response.data.submittedForVerification })
            yield put({ type: SET_SFV_VISITS_PAGINATION, pagination });
        } else {
            yield put({ type: FETCH_SFV_VISITS_ERROR });
            message.error('Failed to fetch submitted to verification visits!');
        }

    } catch (error) {
        message.error('Failed to fetch submitted to verification visits!');
        yield put({ type: FETCH_SFV_VISITS_ERROR, error })
    }

}

function* fetchGroupAdmainSFVVisitsWatcher() {
    yield takeLatest(FETCH_SFV_VISITS, fetchGroupAdminSFVVisits)
}

export default function* rootSaga() {
    yield all([
        fetchGroupAdmainSFVVisitsWatcher()
    ]);
}